<div class="margin-top">
    <document-scanning-request [applicationNumber]="applicationNumber" (cancelRequest)="cancel()" [organization]="organization" [paperApplication]="true" (requestSubmitted)="requestsCreated($event)" (throwError)="rethrowError($event)"></document-scanning-request>
    <a style="display: none;" href="" target="_blank" #downloadLink>Download</a>
</div>